import React from 'react';
import {useLocation} from "react-router-dom";

export default function useInitialPath() {
    const { pathname } = useLocation();

    return pathname.split('/')[1];
}